export default __webpack_public_path__ + "static/ymca-938e13fb4dad94f3fd470d6921c8e819.png";